import { Card, CardBody, CardHeader } from '@nextui-org/react'
import { FC } from 'react'
import { useTankInfoModalStore } from '../../../store/tankInfo/useTankInfoModalStore'
import { CardNameLiteral, SpecSetting } from '../../../types/apiResponse/tankInfoSettingTypes'
import { getCardValue, getSubSpecs } from '../../../types/mappers/tankInfo.mapper'
import { convertMetric } from '../../../utils/metricConvert'
import { makeTitle } from '../../../utils/tankInfo'
import { NoContent } from './NoContent'

export type SpecProps = {
  tankId: string
  cardName: CardNameLiteral
  specSetting: SpecSetting
}

export const SpecCard: FC<SpecProps> = ({ tankId, cardName, specSetting }) => {
  const cardValues = useTankInfoModalStore((state) => state.cardValues)

  // Store에서 이미 계산된 카드 값 사용
  const curValue = cardValues ? getCardValue(cardValues, cardName as any) : undefined
  const { val, metric } = convertMetric(curValue, cardName, specSetting?.metric ?? '')

  const { title, subTitle } = makeTitle(cardName)

  // Store에서 이미 계산된 sub-spec 데이터 사용
  const subSpecsData = cardValues ? getSubSpecs(cardValues, cardName as any) : undefined

  const subSpecs = subSpecsData?.map((subSpec, index) => {
    const filteredSpecSetting = specSetting.subSpec.filter(
      (spec) => spec.specName === subSpec.specName
    )
    const metricString =
      filteredSpecSetting.length === 0
        ? ''
        : filteredSpecSetting[0].metric
          ? filteredSpecSetting[0].metric
          : ''
    const { val, metric } = convertMetric(
      subSpec.curValue,
      subSpec.specName,
      filteredSpecSetting.length === 0 ? '' : filteredSpecSetting[0].metric,
      3
    )
    return (
      <div
        className="spec-card-subspec"
        key={index}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          height: '21px',
        }}
      >
        <span className="text-[14px] text-tdplmiddlegrey font-semibold">{subSpec.specName}</span>
        <span className="text-[18px] text-tdpldarkgrey font-bold">
          {val}
          {metric !== '---' && metric ? (
            <span className="text-[14px] text-tdplmiddlegrey">{' ' + metricString}</span>
          ) : null}
        </span>
      </div>
    )
  })

  return (
    <Card
      className="rounded-lg col-span-1 border border-tdpldarkgrey/60 w-full md:w-auto h-[140px] md:h-[140px] p-4 md:p-[19px] bg-tdplbisque"
      style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}
      data-card-type="spec"
    >
      <CardHeader className="flex flex-row items-start  m-0 p-0 mb-[15px] h-[22px]">
        <p className="text-tdpldarkgrey text-[1rem] font-bold mr-2">{title}</p>
        {subTitle !== undefined ? (
          <p className="text-tdplmiddlegrey text-[1rem]">{subTitle}</p>
        ) : null}
      </CardHeader>
      <CardBody className="m-0 p-0 h-[65px] overflow-hidden">
        {curValue === null || curValue === undefined ? (
          <NoContent />
        ) : (
          <div
            className="spec-card-content"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <div className="flex flex-col w-full md:w-[115px] items-start">
              <p className="text-[20px] font-bold text-tdplprussian">{val}</p>
              <p className="text-[14px] font-normal text-tdplprussian">{metric}</p>
            </div>
            <div className="flex flex-col w-full md:w-[100px] justify-center">{subSpecs}</div>
          </div>
        )}
      </CardBody>
    </Card>
  )
}
